import React from 'react';
import ReactDOM from 'react-dom';
import {css} from 'aphrodite/no-important';
import {styles} from '../styles/SitewideModalStyles';
import FsModal from '../../shared/components/FsModal';
import Cookies from "../../../assets/libs/js-cookie/src/js.cookie";
import {getQueryString} from '../../shared/utils'


/* https://www.w3schools.com/howto/howto_css_modals.asp */
class SitewideModal {
    constructor() {
        this.ELEMENT_ID = 'sitewideModal';
        this.appendModalContainer();
        this.options = {
            cookieName: 'fscom-hideSitewideModal',
            setShownCookie: getQueryString('setShownCookie') || false,
            cookieExpirationInMinutes: getQueryString('cookieExpirationInMinutes') || (60 * 24), // defaults to one day
            duration: getQueryString('duration') || (20 * 1000) // defaults to 20 seconds
        }
    }

    render() {
        ReactDOM.render(<FsModal
                content={this.content()}
                showModal={this.isModalShown()}
                duration={this.options.duration}
            />,
            document.getElementById(this.ELEMENT_ID));

        this.handleShownCookie();
    }

    content() {
        return (
            <div>
                <p className={css(styles.p)}>Sitewide Modal content goes here ...</p>
            </div>
        )
    }

    isModalShown() {
        /* if we have a querystring, we will force to show the modal regardless of cookies or props. */
        const parsed = getQueryString('showSitewideModal');
        if (parsed) {
            return true;
        }

        /* if do not show cookie is set, we won't show the modal */
        let cookie = '';
        if (this.options.setShownCookie && this.options.cookieName) {
            cookie = Cookies.get(this.options.cookieName);
        }
        if (cookie == 1) {
            return false;
        }

        return false;
    }

    appendModalContainer() {
        let div = document.getElementById(this.ELEMENT_ID);
        if(!div) {
            let body = document.body;
            let div = document.createElement('div');
            div.setAttribute('id', this.ELEMENT_ID);
            body.appendChild(div);
        }
    }

    handleShownCookie() {
        if (this.options.setShownCookie && this.options.cookieName) {
            let expireTime = new Date(new Date().getTime() + this.options.cookieExpirationInMinutes * 60 * 1000);
            Cookies.set(this.options.cookieName, 1, {expires: expireTime});
        } else {
            Cookies.set(this.options.cookieName, 0, {expires: -1});
        }
    }
}

export default SitewideModal;



// WEBPACK FOOTER //
// ./react-app-src/sitewideModal/components/SitewideModal.js